import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {connect} from 'react-redux';
import {Modal} from 'antd';
import ListMenu from "..";
import ProductActions from 'bukku/redux/Product/actions';

const {
    archiveProduct,
    deleteProduct,
} = ProductActions;

class ProductListMenu extends Component {
    toggleActivation = record => {
        const { archiveProduct } = this.props;
        const isArchived = record.is_archived;

        Modal.confirm({
            title: (isArchived ? t`Activate Product` : t`Deactivate Product`),
            content: isArchived ?
                t`Do you really want to activate product ${record.name}?` :
                t`Do you really want to deactivate product ${record.name}?`,
            onOk() {
                archiveProduct(record.id, {
                    is_archived: !isArchived,
                });
            },
            onCancel() {},
            okText: (isArchived ? t`Activate` : t`Deactivate`),
            cancelText: t`Cancel`,
        });
    };

    deleteProduct = record => {
        const { deleteProduct } = this.props;

        Modal.confirm({
            title: t`Delete Product`,
            content: t`Do you really want to delete product ${record.name}?`,
            onOk() {
                deleteProduct(record.id);
            },
            onCancel() {},
            okText: t`Delete`,
            cancelText: t`Cancel`,
        });
    };

    getItems = () => {
        const { record } = this.props;

        const items = [];
        items.push({
            key: 'view',
            label: t`View`,
            url: `/products/${record.id}`,
        });

        if (record.is_archived) {
            items.push({
                key: 'activate',
                label: t`Activate`,
                action: () => this.toggleActivation(record),
                isUpdate: true,
            });
        }
        else {
            items.push({
                key: 'deactivate',
                label: t`Deactivate`,
                action: () => this.toggleActivation(record),
                isUpdate: true,
            });
        }

        // Delete
        items.push({
            key: 'delete',
            label: t`Delete`,
            disabled: record.is_used,
            action: () => this.deleteProduct(record),
            isDelete: true,
        });

        return items;
    };

    render() {
        return (
            <ListMenu items={this.getItems()} />
        );
    }
}
export default connect(() => ({
}), {
    archiveProduct,
    deleteProduct,
})(ProductListMenu);
